import React, { useEffect, useState } from "react";
import { Tiny } from "@ant-design/plots";

export const DemoRing = () => {
  const percent = 0.7;
  const config = {
    percent,
    width: 120,
    height: 120,
    color: ["#E8EFF5", "#66AFF4"],
    annotations: [
      {
        type: "text",
        style: {
          text: `${percent * 100}%`,
          x: "50%",
          y: "50%",
          textAlign: "center",
          fontSize: 16,
          fontStyle: "bold",
        },
      },
    ],
  };

  return <Tiny.Ring {...config} />;
};

const CircularProgressBar = ({
  sqSize = 200,
  value = 170,
  strokeWidth = 10,
  percentage = 25,
}) => {
  const radius = (sqSize - strokeWidth) / 2;
  const viewBox = `0 0 ${sqSize} ${sqSize}`;
  const dashArray = radius * Math.PI * 2;
  const dashOffset = dashArray - (dashArray * percentage) / 100;

  return (
    <svg width={sqSize} height={sqSize} viewBox={viewBox}>
      <circle
        className="circle-background"
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
      />
      <circle
        className="circle-progress"
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
        transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
        style={{
          // stroke: value < 30 ? "#F2383A" : value < 60 ? "#F2C049" : "#0DBF4F",
          stroke: "#F2383A",
          strokeDasharray: dashArray,
          strokeDashoffset: dashOffset,
        }}
      />
      <text
        className="circle-text dark:fill-white"
        x="50%"
        y="50%"
        dy=".3em"
        textAnchor="middle"
      >
        {`${value || 0}`}
      </text>{" "}
      <text
        className="circle-subtext"
        x="66%" // Mover el texto "Tickets" hacia la derecha
        y="52%"
        dy=".3em"
        textAnchor="left"
        style={{
          fill: "gray", // Color gris
          fontSize: "14px", // Tamaño más pequeño
        }}
      >
        {`Tickets`}
      </text>
      <text
        className="circle-subtext"
        x="45%" // Mover el texto "Tickets" hacia la derecha
        y="72%"
        dy=".3em"
        textAnchor="left"
        style={{
          fill: "gray", // Color gris
          fontSize: "14px", // Tamaño más pequeño
        }}
      >{`ZTE`}</text>
      {/* <text
        className="circle-subtext"
        x="50%"
        y="55%"
        dy="2.5em" // Para posicionarlo más abajo del texto principal
        textAnchor="middle"
        style={{
          fill: "black", // Color gris
          fontSize: "14px", // Tamaño más pequeño
        }}
      >
        {`Next Month`}
      </text> */}
    </svg>
  );
};

export const Progressbar = ({ value }) => {
  const [percentage, setPercentage] = useState(100);

  useEffect(() => {
    setPercentage(100);
  }, [value]);

  return (
    <div>
      <CircularProgressBar
        strokeWidth={14}
        sqSize={200}
        value={value}
        percentage={percentage}
      />
    </div>
  );
};
